import { Formik } from 'formik';
import React, { forwardRef, useImperativeHandle, useRef } from 'react';
import { strings } from '@constants/strings';
import Input from '../../input';
import { getVideoFormInitialValues, getVideoFormValidationSchema } from './helper';
import { generateEmbedUrl } from '@utils/utils';

const VideoForm = forwardRef(({ addVideo = () => {} }, ref) => {
  const formikRef = useRef(null);

  useImperativeHandle(ref, () => ({
    handleSubmit: () => {
      formikRef?.current?.handleSubmit();
    },
  }));

  return (
    <Formik
      innerRef={formikRef}
      initialValues={getVideoFormInitialValues()}
      validationSchema={getVideoFormValidationSchema()}
      onSubmit={(values) => {
        addVideo(generateEmbedUrl(values?.url));
      }}
    >
      {({ values, touched, errors, setFieldValue, handleSubmit }) => (
        <form onSubmit={handleSubmit}>
          <Input
            label={strings?.embed_video_url}
            placeholder="https://www.youtube.com/embed/8WkuChVeL0s"
            value={values?.url}
            errorMsg={touched?.url && errors?.url && errors?.url}
            onChange={(e) => {
              setFieldValue('url', e?.target?.value);
            }}
            required={true}
          />
        </form>
      )}
    </Formik>
  );
});

export default VideoForm;
